import { isEqual } from 'date-fns'

export const collapseSameDayRange = (value: undefined | { from?: Date; to?: Date }) => {
  const from = value?.from
  const to = from && value?.to && !isEqual(from, value.to) ? value.to : undefined

  return { from, to }
}
